import config from "@Config/index";
import axios from "axios";

const fetchBudgetFriendly = async ({ id, userCurrency }: { id: any; userCurrency?: string }) => {
  const params: any = {
    limit: 10,
    use_open_search: true,
    only: "id,name,canonical_name,location,available,pricing,region_id,images,status",
    type: "empty",
    methods: "meta_short,images_with_featured",
  };
  if (userCurrency) {
    params.user_currency = userCurrency;
  }

  return axios.get(`${config.API_URL}/api/v0/inventories/${id}/budget_friendly`, { params });
};

export default fetchBudgetFriendly;
